export const CREATE_GRAY_JOB_ISSUE = 'CREATE_GRAY_JOB_ISSUE';
export const GET_GRAY_JOB_ISSUES = 'GET_GRAY_JOB_ISSUES';
export const GRAY_JOB_ISSUE_REQUEST = 'GRAY_JOB_ISSUE_REQUEST';
export const UPDATE_GRAY_JOB_ISSUE = 'UPDATE_GRAY_JOB_ISSUE';
export const DELETE_GRAY_JOB_ISSUE = 'DELETE_GRAY_JOB_ISSUE';
export const GRAY_JOB_ISSUE_REQUEST_FAILURE = 'GRAY_JOB_ISSUE_REQUEST_FAILURE';
export const SET_RECEIVE_RETURN_DETAIL_BY_ID = 'SET_RECEIVE_RETURN_DETAIL_BY_ID';
export const GET_WEAVER_PARTIES = 'GET_WEAVER_PARTIES';